import { ITEM_DATABASE } from '../content/generated/items.gen';
import { MOB_CONFIG, NPC_CONFIG } from '../content/generated/entities.gen';

export type QuestObjectiveKind = 'kill' | 'collect' | 'explore' | 'talk' | 'level' | 'equip';

function titleCaseId(id: string): string {
  return id
    .replace(/[_-]+/g, ' ')
    .replace(/\b\w/g, letter => letter.toUpperCase());
}

/** Resolve an objective's machine id to the canonical player-facing name. */
export function questObjectiveTargetName(type: QuestObjectiveKind, targetId: string, targetCount = 1): string {
  if (type === 'collect' || type === 'equip') return ITEM_DATABASE[targetId]?.name ?? titleCaseId(targetId);
  if (type === 'kill') return MOB_CONFIG[targetId]?.name ?? titleCaseId(targetId);
  if (type === 'talk') return NPC_CONFIG[targetId]?.name ?? titleCaseId(targetId);
  if (type === 'level') return `Level ${Math.max(targetCount, 1)}`;
  if (type === 'explore' && targetId === 'drowned_road_hush_nook') return 'A place beneath the road';
  if (type === 'explore' && targetId === 'pig_beach') return 'Brinebristle Strand';
  return titleCaseId(targetId);
}

